import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ImageUploader } from "@/components/profile/ImageUploader";

interface ImagesCardProps {
  profileImageUrl: string | null;
  coverImageUrl?: string | null;
  onProfileImageUpload: (file: File) => Promise<void>;
  onCoverImageUpload?: (file: File) => Promise<void>;
  onProfileImageRemove: () => Promise<void>;
  onCoverImageRemove?: () => Promise<void>;
  showCoverImage?: boolean;
}

export const ImagesCard = ({
  profileImageUrl,
  coverImageUrl,
  onProfileImageUpload,
  onCoverImageUpload,
  onProfileImageRemove,
  onCoverImageRemove,
  showCoverImage = false
}: ImagesCardProps) => {
  return (
    <Card className="bg-[#1A2233] border-[#2D3748] col-span-1">
      <CardContent className="pt-6 px-6">
        <div className="space-y-6">
          <div className="space-y-1">
            <h3 className="text-lg font-semibold text-white">Imagem de perfil</h3>
            <p className="text-sm text-gray-400">
              Esta imagem será exibida em toda a plataforma: perfil público, chat, comentários e cards de mentoria.
            </p>
          </div>

          <ImageUploader
            currentImageUrl={profileImageUrl}
            title="Imagem de perfil"
            onImageSelected={onProfileImageUpload}
            onRemoveImage={onProfileImageRemove}
            aspectRatio="square"
          />

          {showCoverImage && onCoverImageUpload && onCoverImageRemove && (
            <>
              <div className="space-y-1 pt-4">
                <h3 className="text-lg font-semibold text-white">Banner de perfil</h3>
                <p className="text-sm text-gray-400">
                  Este banner aparecerá no topo do seu perfil público, nos cards de mentoria e na página de busca de mentores.
                </p>
              </div>

              <ImageUploader
                currentImageUrl={coverImageUrl}
                title="Banner de perfil"
                onImageSelected={onCoverImageUpload}
                onRemoveImage={onCoverImageRemove}
                aspectRatio="banner"
              />
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
